export default "__VITE_ASSET__B4CAg$ZX__"